<template>
  <div class="@container">
    <div class="mb-2 flex items-center gap-2">
      <app-rating-stars :value="rating.global_satisfaction" />
      <p class="flex-auto text-ellipsis text-sm">
        <strong>{{ rating.author.full_name }}</strong>
        <span
          v-if="rating.author.job_title && rating.author.company_name"
          class="hidden @lg:inline"
        >
          - {{ rating.author.job_title }} @{{ rating.author.company_name }}
        </span>
      </p>
      <p class="hidden whitespace-nowrap text-xs text-subtle @lg:block">
        {{ formattedDateLabel }}
      </p>
      <p class="block whitespace-nowrap text-xs text-subtle @lg:hidden">
        {{ formattedDateLabelShort }}
      </p>
    </div>

    <app-text-clamped
      v-if="rating.comment"
      class="text-sm leading-[1.4rem] before:mr-1 before:content-['“'] after:ml-1 after:content-['”']"
      :leading="1.4"
      :max-lines="2"
      trigger-color="dark"
      trigger-size="xs"
    >
      {{ rating.comment }}
    </app-text-clamped>
  </div>
</template>

<script lang="ts" setup>
import type { CourseRatingItemView } from "~~/model/course.model";

const properties = defineProps<{
  rating: CourseRatingItemView;
}>();

const formattedDateLabel = useI18nRelativeTime(properties.rating.created_at);
const formattedDateLabelShort = useI18nRelativeTime(
  properties.rating.created_at,
  { style: "short" },
);
</script>
